// extracted by mini-css-extract-plugin
export default {"formContainer":"ConfirmModal_formContainer__HqN+E","error":"ConfirmModal_error__TQ-5e"};